module.exports = __webpack_public_path__ + "static/media/bu-summary-location.d1c63bdd.svg";